const DATE = new Intl.DateTimeFormat(undefined, { day: "numeric", month: "short", year: "numeric" });
const DATE_TIME = new Intl.DateTimeFormat(undefined, {
	day: "numeric",
	month: "short",
	year: "numeric",
	hour: "numeric",
	minute: "2-digit",
});
const RELATIVE = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });

export function formatDate(value: string | null | undefined): string {
	if (!value) return "—";
	const date = new Date(value);
	return Number.isNaN(date.getTime()) ? "—" : DATE.format(date);
}

export function formatDateTime(value: string | null | undefined): string {
	if (!value) return "—";
	const date = new Date(value);
	return Number.isNaN(date.getTime()) ? "—" : DATE_TIME.format(date);
}

const RELATIVE_STEPS: Array<[Intl.RelativeTimeFormatUnit, number]> = [
	["second", 60],
	["minute", 60],
	["hour", 24],
	["day", 7],
	["week", 4.345],
	["month", 12],
];

export function formatRelative(value: string | null | undefined): string {
	if (!value) return "Not yet checked";
	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return "Not yet checked";

	let delta = (date.getTime() - Date.now()) / 1000;
	for (const [unit, size] of RELATIVE_STEPS) {
		if (Math.abs(delta) < size) return RELATIVE.format(Math.round(delta), unit);
		delta /= size;
	}
	return RELATIVE.format(Math.round(delta), "year");
}

export function formatMoney(amountMinor: number, currency: string): string {
	return new Intl.NumberFormat(undefined, { style: "currency", currency }).format(amountMinor / 100);
}

export function formatCount(count: number, singular: string, plural: string): string {
	return `${count} ${count === 1 ? singular : plural}`;
}
